import {MenuCategoryResponse} from "./menu-category-response";

export class MenuCategoryListResponse {
    menuCategoryList: MenuCategoryResponse[] = [];
}
